import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-total-registered',
    templateUrl: './total-registered.component.html',
    styleUrls: ['./total-registered.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TotalRegisteredComponent implements OnInit {
    label: string;
    amount: number;

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getTotalRegistered().subscribe(r => {
            this.label = r.value.label;
            this.amount = r.value.value;
        });
    }
}
